export const buildUrl = (domain: string, path: string) => {
  const normalizedDomain = domain.replace(/\/+$/, '');
  const normalizedPath = path.replace(/^\/+/, '');
  return `${normalizedDomain}/${normalizedPath}`;
};
